// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2fhHA","header":"MergedInvoice_header__39ffq"};